export function LikeFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M5 12H2v9h3v-9zM7 12v9h10.086c.575 0 1.117-.27 1.463-.731l.25-.334a1.348 1.348 0 00-.126-1.762.245.245 0 010-.346l.35-.35a2.236 2.236 0 00.54-2.288.407.407 0 01.047-.354l.148-.222a2.735 2.735 0 00.319-2.382l-.013-.04a.411.411 0 01.048-.359l.076-.113A2.07 2.07 0 0018.465 8.5H12.5V4.803a1.5 1.5 0 00-2.332-1.248l-.148.098a1.767 1.767 0 00-.706.943L7 12z"
      ></path>
    </svg>
  );
}
